<div *ngIf="!adHocTransaction">
	<div class="d-flex flex-fill w-100">
		<div class="h-100 w-100 mx-1 flex-fill">
			<div class="d-flex">
				<div class="h3">Transaction</div>
			</div>

			<p-divider></p-divider>
			<div class="p-grid">
				<div class="p-col">
					{{ moment(transactionSelected.transactionDateTime).format("l LT") }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Purchase Value:</div>
				<div class="p-col">
					{{ transactionSelected.value | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Paid Amount:</div>
				<div class="p-col">
					{{ transactionSelected.transactionAmount | currency }}
				</div>
			</div>
			<div class="p-grid" *ngIf="transactionSelected.promoCode">
				<div class="p-col">Promo Code:</div>
				<div class="p-col">
					{{ transactionSelected.promoCode }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Focus Check #</div>
				<div class="p-col">
					{{ transactionSelected.CheckV2?.checkNumber }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Invoice #:</div>
				<div class="p-col">
					{{ transactionSelected.invoice }}
				</div>
			</div>
		</div>
		<div *ngIf="transactionSelected.activated" class="card h-100 w-100 mx-1 flex-fill">
			<div class="d-flex">
				<div class="h3">Card Info</div>
			</div>
			<p-divider></p-divider>
			<div class="d-flex flex-column">
				<div class="m-2">
					{{ transactionSelected.EGiftCardPool.cardNumber }}
				</div>
				<div class="m-2">Activated on {{ moment(transactionSelected.EGiftCardPool.activatedDateTime).format("l LT") }}</div>
				<div class="m-2">Current balance {{ transactionSelected.EGiftCardPool.cardBalance | currency }}</div>
			</div>
		</div>
	</div>
	<div class="d-flex mt-2">
		<div class="h-100 w-100 mx-1">
			<div class="d-flex">
				<div class="h3">Purchaser</div>
			</div>

			<p-divider></p-divider>
			<div class="d-flex flex-column">
				<div class="m-2">{{ transactionSelected.purchaserFirstName }} {{ transactionSelected.purchaserLastName }}</div>
				<div class="m-2">
					{{ transactionSelected.purchaserEmail }}
				</div>
				<div class="m-2">Zip code: {{ transactionSelected.purchaserZipcode }}</div>
			</div>
		</div>
		<div class="card h-100 w-100 mx-1">
			<div class="d-flex">
				<div class="h3">Recipient</div>
			</div>

			<p-divider></p-divider>

			<div class="d-flex flex-column">
				<div class="m-2" *ngIf="transactionSelected.delaySend">
					Scheduled Send
					<div *ngIf="!editTransaction">Scheduled Send</div>
					<div *ngIf="editTransaction">
						<p-calendar
							name="sendDateTime"
							id="sendDateTime"
							[(ngModel)]="transactionSelected.sendDateTime"
							[showTime]="true"
							hourFormat="12"
							inputId="sendDateTime"
							styleClass="w-100"
						></p-calendar>
					</div>
				</div>
				<div class="m-2" *ngIf="!transactionSelected.recipientLastName">
					<div *ngIf="!editTransaction">
						{{ transactionSelected.recipientName }}
					</div>
					<div *ngIf="editTransaction">
						<mat-form-field class="">
							<mat-label>Recipient Name</mat-label>
							<input matInput #recipientNameField type="text" name="recipientNameField" [(ngModel)]="transactionSelected.recipientName" />
						</mat-form-field>
					</div>
				</div>
				<div class="m-2" *ngIf="transactionSelected.recipientLastName">
					{{ transactionSelected.recipientFirstName }} {{ transactionSelected.recipientLastName }}
				</div>
				<div class="m-2">
					<div *ngIf="!editTransaction">
						{{ transactionSelected.recipientEmail }}
					</div>
					<div *ngIf="editTransaction">
						<mat-form-field class="">
							<mat-label>Recipient Email</mat-label>
							<input matInput #recipientEmailField type="text" name="recipientEmailField" [(ngModel)]="transactionSelected.recipientEmail" />
						</mat-form-field>
					</div>
				</div>
				<div class="m-2">
					<div *ngIf="!editTransaction">
						<em>
							{{ transactionSelected.note }}
						</em>
					</div>
					<div *ngIf="editTransaction">
						<mat-form-field class="formClass">
							<mat-label>Note to Recipient</mat-label>
							<textarea matInput #recipientNoteField name="recipientNoteField" [(ngModel)]="transactionSelected.note"></textarea>
						</mat-form-field>
					</div>
				</div>
				<div class="m-2">Email sent on {{ moment(transactionSelected.sendDateTime).format("l LT") }}</div>
			</div>
		</div>
	</div>
	<!-- <div *ngIf="!transactionSelected.activated" class="d-flex">
        <div class="ms-auto">
            <p-button *ngIf="!editTransaction" pRipple styleClass="p-button-raised m-2" (click)="initEditTransaction()">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","pencil"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
            <p-button *ngIf="editTransaction" pRipple styleClass="p-button-raised p-button-danger m-2"
                (click)="editTransaction = false; transactionSelected = clonedTransaction">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","times"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
            <p-button *ngIf="editTransaction" pRipple styleClass="p-button-raised p-button-success m-2" (click)="updateEGiftTransaction()">
                <ng-template pTemplate="content">
                    <fa-icon [icon]='["far","save"]' size="lg" class="ms-1"></fa-icon>
                </ng-template>
            </p-button>
        </div>
    </div> -->
</div>

<div *ngIf="adHocTransaction" class="d-flex flex-column p-fluid">
	<div class="h-100 w-100 mx-1">
		<div class="d-flex">
			<div class="h3">New AdHoc Transaction</div>
		</div>
		<p-divider></p-divider>

		<div class="d-flex flex-column">
			<span class="p-float-label mt-2">
				<input pInputText #recipientName type="text" name="recipientName" [(ngModel)]="transactionSelected.recipientName" class="w-100 m-2" />
				<label class="ms-3" for="recipientName">Recipient Name</label>
			</span>
			<span class="p-float-label mt-2">
				<input pInputText #recipientEmail type="email" name="recipientEmail" [(ngModel)]="transactionSelected.recipientEmail" class="w-100 m-2" />
				<label class="ms-3" for="recipientEmail">Recipient Email</label>
			</span>
			<span class="p-float-label mt-2">
				<p-inputNumber
					#transactionValue
					max="2000.00"
					[(ngModel)]="transactionSelected.value"
					inputId="currency-us"
					mode="currency"
					currency="USD"
					locale="en-US"
					styleClass="w-100 m-2"
				></p-inputNumber>
				<label class="ms-3" for="transactionValue">Gift Card Amount</label>
			</span>
			<span class="p-float-label mt-2">
				<textarea pInputTextarea #note class="w-100 m-2" [(ngModel)]="transactionSelected.note"></textarea>
				<label class="ms-3 mt-1" for="note">Note to guest</label>
			</span>
			<p-selectButton
				required
				name="sendSelect"
				id="sendSelect"
				[options]="sendOptions"
				[(ngModel)]="transactionSelected.delaySend"
				optionLabel="label"
				optionValue="value"
				styleClass="w-100 m-2"
			>
			</p-selectButton>
			<span class="p-float-label mt-2">
				<p-calendar
					required
					name="sendDateTime"
					id="sendDateTime"
					[(ngModel)]="sendDateTime"
					[showTime]="true"
					hourFormat="12"
					inputId="sendDateTime"
					(onSelect)="onDelaySendDateSelect()"
					(onInput)="onDelaySendDateSelect()"
					styleClass="w-100 m-2"
					[disabled]="!transactionSelected.delaySend"
				></p-calendar>
				<label class="ms-3" for="sendDateTime">When would you like to send...</label>
			</span>
		</div>
	</div>
</div>
